/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Site_BusyInputs */

const en_site_url_error_site_busy = /** @type {(inputs: Site_Url_Error_Site_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two website dissections are still running. Wait for one to finish.`)
};

const id_site_url_error_site_busy = /** @type {(inputs: Site_Url_Error_Site_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua bedah website masih berjalan. Tunggu salah satunya selesai.`)
};

/**
* | output |
* | --- |
* | "Two website dissections are still running. Wait for one to finish." |
*
* @param {Site_Url_Error_Site_BusyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_site_busy = /** @type {((inputs?: Site_Url_Error_Site_BusyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Site_BusyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_site_busy(inputs)
	return en_site_url_error_site_busy(inputs)
});